import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {
    ILoyaltySubscriptions,
    ILoyaltySubscriptionListItem,
} from '@/entity/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscription.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltySubscriptionGeneralRequestType } from '@/form/loyalty/loyaltySubscription/LoyaltySubscriptionGeneral.types';
import { ResponseDataType } from '@/form/form.types';
import { IStoreReady } from '@/store/lib/storeSupport';

import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'loyaltySubscription',
    store,
    dynamic: true,
})
class LoyaltySubscriptionModule extends VuexModule implements  IStoreReady{
    public loyaltySubscriptions: ILoyaltySubscriptions | null = null;
    public loyaltySubscription: ILoyaltySubscriptionListItem | null = null;
    loyaltySubscriptionsLoaded = false;
    loyaltySubscriptionLoaded = false;
    ready = false

    @MutationAction
    async fetchAll(
        data?: PaginationRequestType
    ): Promise<{ loyaltySubscriptions: ILoyaltySubscriptions; loyaltySubscriptionsLoaded: boolean }> {
        let loyaltySubscriptionsLoaded = false;
        const loyaltySubscriptions = await store.$repository.loyaltySubscription.fetchAll(prepareFormData(data));
        console.log('LoyaltySubscriptionModule loyaltySubscriptions', loyaltySubscriptions)
        if (loyaltySubscriptions) {
            loyaltySubscriptionsLoaded = true;
        }
        return { loyaltySubscriptions, loyaltySubscriptionsLoaded };
    }
    @MutationAction
    async fetchData(
        data: PaginationRequestType
    ): Promise<{ loyaltySubscription: ILoyaltySubscriptionListItem; loyaltySubscriptionLoaded: boolean }> {
        let loyaltySubscriptionLoaded = false;
        const loyaltySubscription = await store.$repository.loyaltySubscription.fetchData(data);
        console.log('LoyaltySubscriptionModule loyaltySubscription', loyaltySubscription)
        if (loyaltySubscription) {
            loyaltySubscriptionLoaded = true;
        }
        return { loyaltySubscription, loyaltySubscriptionLoaded };
    }

    @Mutation
    async clearItems() {
        this.loyaltySubscriptions=null;
    }

    @Action({ rawError: true })
    async create(data: LoyaltySubscriptionGeneralRequestType): Promise<ResponseDataType> {
        console.log('LoyaltySubscriptionModule create' )
        return await store.$repository.loyaltySubscription.create(data);
    }
    @Action({ rawError: true })
    async update(data: LoyaltySubscriptionGeneralRequestType): Promise<ResponseDataType> {
        console.log('LoyaltySubscriptionModule update' )

        return await store.$repository.loyaltySubscription.update(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}

export const LoyaltySubscriptionStore = getModule(LoyaltySubscriptionModule);
